import React, { useState, useEffect } from 'react'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { Link, withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ApiService from '../../../Services/ApiService'
import { useCallback } from 'react'
import { addButtonSpinner, removeButtonSpinner, removeRightSectionSpinner, addRightSectionSpinner } from '../../../store/actions'
import { ERROR_KEY, INACTIVE_ACCOUNT_INFO_MSG, MERCHANT_USER_TYPE_ID, SUCCESS_KEY } from '../../../Constants/MainKeys'
import AlertService from '../../../Services/alertService'
import uuid from 'react-uuid'
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  UncontrolledAlert,
} from "reactstrap"
import { Table } from "react-bootstrap"
import HtmlHead from '../../../components/HtmlHead/HtmlHead'
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner'
import NoData from '../../../components/NoData/NoData'
import ReactPaginate from 'react-paginate'
import ReactSelectOption from '../../../components/SelectOptions/ReactSelectOption'
import MainService from '../../../Services/MainService'
import { useWindowSize } from '../../../components/Hooks/useWindowSize'
import OverlayTriggerComponent from '../../../components/OverlayTriggerComponent/OverlayTriggerComponent'

const buttonSpinnerId = uuid();

const Users = (props) => {

  const title = "Significant Controllers"
  const description = "";
  const pageSize = 10;
  const dispatch = useDispatch();
  const { buttonSpinners } = useSelector(state => state.Spinners);
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const { user } = useSelector(state => state.Login);
  const { language } = useSelector(state => state.Languages);
  const [users, setUsers] = useState([]);
  const [activePageNumber, setActivePageNumber] = useState(0);
  const [pagination, setPagination] = useState(null);
  const [type, setType] = useState(0);
  const [types, setTypes] = useState([]);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const windowSize = useWindowSize();

  useEffect(() => {
    getUsers(1, type, setIsShowAlert);
  }, [])

  const handlePageClick = (event) => {
    getUsers(event.selected + 1, type)
    setActivePageNumber(event.selected);
  };

  const getUsers = (pageNumber, type, cb) => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    (user.userTypeId === MERCHANT_USER_TYPE_ID ?
      ApiService.getUsersAsMerchant(user.organizationId, type, pageNumber, pageSize) :
      ApiService.getUsersAsAgent(user.activeAgentId, type, pageNumber, pageSize))
      .then(response => {
        if (response && response.pagination) setPagination(JSON.parse(response.pagination));
        if (response && response.data) {
          if (response.data.filter && response.data.filter.types) {
            let _types = [...response.data.filter.types];
            _types.unshift({ key: 0, value: "All" });
            setTypes(_types);
          };
          if (response.data.significantControllers && response.data.significantControllers.length) {
            setUsers(response.data.significantControllers);
            cb && cb(true);
          } else {
            setUsers();
          }
        }
      }).catch(error => getFail(error)).finally(() => {
        extractRightSectionSpinner(spinnerId)
      })
  }

  const onSelectOptionsChange = (item, cb) => {
    if (!item) { return false; }
    cb(item.value);
    getUsers(1, item.value)
  }

  const deleteSignificantController = (itemId, spinnerId) => {
    AlertService.alertConfirm(
      `Are you sure ?`,
      "",
      "Yes",
      "No"
    ).then(() => {
      setButtonSpinner(spinnerId);
      (user.userTypeId === MERCHANT_USER_TYPE_ID ?
        ApiService.deleteSignificantControllerAsMerchant(itemId) :
        ApiService.deleteSignificantControllerAsAgent(itemId)).then(() => {
          AlertService.alert(SUCCESS_KEY, "Significant Controller deleted successfully");
          setUsers(users.filter(item => item.id !== itemId))
        }).catch(error => getFail(error)).finally(() => {
          extractButtonSpinner(spinnerId)
        })
    })
  }

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const setButtonSpinner = useCallback(spinner => {
    dispatch(addButtonSpinner(spinner));
  }, []);

  const extractButtonSpinner = useCallback(spinner => {
    dispatch(removeButtonSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />
        <div className="container-fluid">
          {
            isShowAlert ?
              <UncontrolledAlert color="info" role="alert">
                All Directors and Ultimate Beneficial Owners i.e. equity holding greater than 20%
              </UncontrolledAlert>
              : null
          }
          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Significant Controllers"
          />
          <div>
            <Card>
              <CardBody>
                <div className='mb-3 d-sm-flex align-items-end justify-content-between'>
                  {/* {
                    user.isActive ? */}
                  <div style={{ minWidth: "200px" }}>
                    <Label>Choose type</Label>
                    <ReactSelectOption
                      value={type}
                      selectedValue={(() => {
                        const selectedValue = { ...types.find(data => data.key === type) };
                        if (Object.keys(selectedValue).length) {
                          selectedValue.label = selectedValue.value;
                          selectedValue.value = selectedValue.key;
                          return selectedValue;
                        } else {
                          return { label: "Choose type", value: null }
                        }
                      })()}
                      items={types.map(data => ({ label: data.value, value: data.key }))}
                      onChange={(item) => onSelectOptionsChange(item, setType)}
                    />
                  </div>
                  {/* : null
                  } */}
                  {
                    users && users.length ?
                      <div className='d-flex justify-content-end mt-2 mt-md-0'>
                        <Button
                          type="button"
                          color="primary"
                          className='shadow-sm'
                          onClick={() => props.history.push(`/${language}/significant-controllers-form`)}
                        >
                          + &nbsp; Create Significant Controller
                        </Button>
                      </div>
                      : null
                  }
                </div>
                <div>
                  {
                    users && users.length ?
                      <div>
                        <Table striped bordered hover responsive>
                          <thead>
                            <tr className='cursor-default'>
                              <th className="text-nowrap">Full Name</th>
                              <th className="text-nowrap">Email Address</th>
                              <th className="text-nowrap">Phone Number</th>
                              <th className="text-nowrap">Type</th>
                              <th className="text-nowrap">Shareholding Percentage</th>
                              <th className={`text-nowrap ${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              users.map((item, index) => {
                                return <tr key={index} className='cursor-default'>
                                  <td className='fw-500'>{item.fullName}</td>
                                  <td className='fw-500'>{item.email}</td>
                                  <td className='fw-500 text-nowrap'>{MainService.formatPhoneNumber(item.phoneNumber)}</td>
                                  <td className='fw-500'>{item.typeName}</td>
                                  <td className='fw-500'>{item.percentage}%</td>
                                  <td className={`${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>
                                    <div className="d-flex justify-content-center">
                                      <OverlayTriggerComponent text="Edit">
                                        <Link
                                          to={`/${language}/significant-controllers-form/${item.id}`}
                                          className='shadow-sm me-2 text-nowrap btn btn-primary'
                                        >
                                          <i className="bx bx-edit-alt table-icon" />
                                        </Link>
                                      </OverlayTriggerComponent>
                                      <OverlayTriggerComponent text='Delete'>
                                        <Link
                                          to={`/${language}/significant-controllers-form/${item.id}`}
                                          className={`shadow-sm me-2 text-nowrap btn btn-danger ${buttonSpinners.includes(`${buttonSpinnerId}_user_${index}`) ? "disabled" : ""}`}
                                        >
                                          {
                                            buttonSpinners.includes(`${buttonSpinnerId}_user_${index}`) ?
                                              <i className="bx bx-loader bx-spin table-icon"></i>
                                              : <i className="bx bx-trash table-icon" />
                                          }
                                        </Link>
                                      </OverlayTriggerComponent>
                                    </div>
                                  </td>
                                </tr>
                              })
                            }
                          </tbody>
                        </Table>
                        {
                          pagination && pagination.TotalPages && pagination.TotalPages > 1 ?
                            <div className='py-3 d-flex justify-content-end'>
                              <ReactPaginate
                                nextLabel="Next"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                                pageCount={pagination.TotalPages}
                                previousLabel="Previous"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                                forcePage={activePageNumber}
                              />
                            </div>
                            : null
                        }

                      </div>
                      :
                      <div>
                        <NoData />

                        <div className='d-flex justify-content-center'>
                          <Button
                            type="button"
                            color="primary"
                            className='shadow-sm mb-3'
                            onClick={() => props.history.push(`/${language}/significant-controllers-form`)}
                          >
                            Create Significant Controller
                          </Button>
                        </div>
                      </div>
                  }
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </>
  )
}

export default withRouter(Users)